import PolicyReducerActionTypes from "./policyActionTypes"

const policyState = {
  policyReport: null,
  isLoading: true,
  filters: new Map(),
  hasCampaigns: false,
  isDynamicCreative: false,
}

const addStatusProps = (drafts) => {
  return Object.keys(drafts).reduce((acc, draftId) => {
    const {
      creatives,
      is_text_review_required = false,
      headlines = [],
      descriptions = [],
      long_headline = [],
      primary_texts = [],
      display_thumbnails = [],
      provider_id,
      article_style,
      url,
    } = drafts[draftId]

    acc[draftId] = {
      is_text_review_required,
      creatives: creatives.map((creative) => ({
        ...creative,
        imageReviewStatus: false,
      })),
      headlines: headlines.map((headline) => ({
        value: headline,
        reviewStatus: false,
      })),
      descriptions: descriptions.map((description) => ({
        value: description,
        reviewStatus: false,
      })),
      long_headline: long_headline.map((long_headline) => ({
        value: long_headline,
        reviewStatus: false,
      })),
      primary_texts: primary_texts.map((primary_text) => ({
        value: primary_text,
        reviewStatus: false,
      })),
      display_thumbnails: display_thumbnails.map((display_thumbnail) => ({
        ...display_thumbnail,
        reviewStatus: false,
      })),
      provider_id,
      article_style,
      url,
    }

    return acc
  }, {})
}

function policyReducer(state = policyState, action) {
  if (state == undefined || action == undefined) {
    return []
  }
  switch (action.type) {
    case PolicyReducerActionTypes.FETCH_POLICY_RESPONSE:
      return Object.assign({}, state, {
        policyReport: addStatusProps(action.drafts),
        hasData: action.hasCampaigns,
        isLoading: false,
      })

    case PolicyReducerActionTypes.UPDATE_POLICY_REPORT:
      return Object.assign({}, state, {
        policyReport: action.drafts,
      })

    case PolicyReducerActionTypes.POLICY_LIST_LOADING:
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      })

    case PolicyReducerActionTypes.ROLLBACK_POLICY_PAGE:
      return Object.assign({}, state, {
        isLoading: false,
        hasCampaigns: true,
        policyReport: null,
        filters: new Map(),
      })

    case PolicyReducerActionTypes.UPDATE_FILTER_POLICY:
      return Object.assign({}, state, {
        filters: action.filters,
      })

    case PolicyReducerActionTypes.CLEAR_POLICY_FILTER:
      return Object.assign({}, state, {
        filters: new Map(),
      })

    default:
      return state
  }
}
export { policyReducer }
